import styled from 'styled-components'

export const CancelButtonWrapper = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;
`

export const UploaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: white;
`
